import TEMPLATE_URL from "emun.salesrep/territory-manager/territory/picker/territory-picker.htm";
import controller from "emun.salesrep/territory-manager/territory/picker/territory-picker.controller";
import open from "webmodals/open";

const NOOP = () => { };

export default ({
	size = "lg",
	backdrop = "static",
	templateUrl = TEMPLATE_URL,
	placement = undefined, // "right",
	title = "Select Territories(s)...",
	subTitle = "",
	view = "table",
	single = false,
	viewSelections = false,
	okButtonText = "OK",
	closeButtonText = single ? "Close" : "Cancel",
	selected = {},
	criteria = {},
	onToggle = NOOP,
	onTerritorySelected = NOOP,
	onTerritoryDeselected = NOOP
} = {}) =>
	open({
		size,
		backdrop,
		templateUrl,
		console: console.debug(templateUrl, {
			placement,
			size,
			backdrop,
			title,
			view
		}),
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => ({
				title,
				subTitle,
				onTerritorySelected,
				onTerritoryDeselected,
				onToggle,
				criteria,
				view,
				viewSelections,
				okButtonText,
				closeButtonText,
				single,
				selected
			})
		}
	}).result;
